/**
 * O QUE O APARELHO DIZ AO PORTAL ANTES DE PREPARAR (03/11/2026; o #1265 no iPhone e a reprodução na cópia,
 * `backend/src/services/salaDuplicadaNaTroca.test.ts`). Celular e computador, pela mesma regra.
 *
 * A SALA QUE O PORTAL PODE ADOTAR (`salasNoAparelho`, `prepararSalaDoAplicativo`): só a que o motor aceita atualizar — com a
 * prova no aparelho e NUNCA aberta. A aberta não é atualizada pelo motor ("Esta sala já foi aberta neste aparelho"), e a
 * que teve a prova apagada pela limpeza não abre mais: mandadas, o portal as adotava e a preparação nunca dava sala.
 *
 * A SALA QUE O APARELHO JÁ ENCERROU E ENVIOU: encerrada sem nenhuma entrega, o envio é "nada a enviar" — nada vai ao portal
 * (`desktop/src/sala/envio.js`), e lá ela continua aberta (ACTIVE). O portal a reaproveitava na próxima preparação deste
 * aparelho, e o motor a recusava. Antes de preparar, a página a encerra no portal (`POST /api/offline-rooms/:id/encerrar`,
 * a mesma do botão; encerrar de novo não muda nada, e a sala encerrada continua aceitando o envio do que já foi colhido —
 * `encerrarNoPortal.ts`). Funções puras, sem a API: o teste na cópia as aplica à lista real do motor.
 */
interface SalaDoAparelho {
  id: number;
  simuladoId?: number;
  pacoteApagadoEm?: string | null;
  estado?: { abertaEm?: number | null; iniciadaEm?: number | null; encerradaEm?: number | null; envio?: { situacao?: string } | null } | null;
  abertaAgora?: boolean;
}

const CONCLUIDO = new Set(['enviado', 'nada-a-enviar']);

/** As salas que o portal pode adotar como deste aparelho: com a prova aqui e nunca abertas. */
export function salasAdotaveis(salas: SalaDoAparelho[]): number[] {
  return salas.filter((s) => !s.pacoteApagadoEm && !s.estado && !s.abertaAgora).map((s) => s.id);
}

/** As salas deste simulado que o aparelho encerrou e cujo envio terminou: o portal as encerra também. */
export function salasAEncerrarNoPortal(salas: SalaDoAparelho[], simulationId: number): number[] {
  return salas.filter((s) => s.simuladoId === simulationId && !s.abertaAgora && !!s.estado?.encerradaEm && CONCLUIDO.has(String(s.estado?.envio?.situacao ?? ''))).map((s) => s.id);
}
